import React, { Fragment, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getExGrupos,
  getMasGrupos,
  setExGrupoSeleccionado,
  unsetExGrupoSeleccionado,
} from '../../../actions/extrusion/ExGrupos'
import {
  getMasPerfiles,
  setPerfilSeleccionado,
  unsetPerfilSeleccionado,
} from '../../../actions/extrusion/ExPerfiles'
import {
  getExSeries,
  getMasSeries,
  setExSerieSeleccionada,
  unsetExSerieSeleccionada,
} from '../../../actions/extrusion/ExSeries'
import {
  getExSubSeries,
  getMasSubSeries,
  setExSubSerieSeleccionada,
  unsetExSubSerieSeleccionada,
} from '../../../actions/extrusion/ExSubSeries'
import { getImagenesPerfiles } from '../../../actions/extrusion/ImagenesPerfiles'
import {
  obtenerGruposBusqueda,
  obtenerPerfilesBusqueda,
  obtenerSeriesBusqueda,
  obtenerSubseriesBusqueda,
} from '../../../helpers/extrusion/funciones'
import { obtenerValorParametro } from '../../../helpers/funciones'
import i18n from '../../../lang/idiomas'
import ElementoGridExtrusion from './ElementoGridExtrusion'
import FormularioExtrusion from './FormularioExtrusion'

const MenuExtrusion = () => {
  const dispatch = useDispatch()

  const portal = useSelector(state => state.portal.portal)
  const exGrupos = useSelector(state => state.exgrupos)
  const exSeries = useSelector(state => state.exseries)
  const exSubseries = useSelector(state => state.exsubseries)
  const exPerfiles = useSelector(state => state.experfiles)
  const cargandoImagenes = useSelector(state => state.imagenesPerfiles.isLoading)

  // Cargamos parametros del modulo
  const modo_listado = obtenerValorParametro(portal.parametros_ecom, 'MODO_LISTADO', 'ARTA')

  const prevPerfiles = useRef()

  useEffect(() => {
    if (
      exPerfiles.perfiles.perfiles.length > 0 &&
      prevPerfiles.current !== exPerfiles.perfiles.perfiles &&
      !cargandoImagenes
    ) {
      dispatch(getImagenesPerfiles('', '', exPerfiles.perfiles.perfiles))
    }
    prevPerfiles.current = exPerfiles.perfiles.perfiles
  }, [exPerfiles.perfiles.perfiles])

  useEffect(() => {
    if (
      (portal.ex_agrupacion_perfiles === 'GSBP' || portal.ex_agrupacion_perfiles === 'GSP') &&
      (!exGrupos?.grupos?.grupos || exGrupos.grupos.grupos.length === 0)
    ) {
      dispatch(getMasGrupos())
    } else if (
      portal.ex_agrupacion_perfiles === 'SP' &&
      (!exSeries?.series?.series || exSeries?.series?.series.length === 0)
    ) {
      dispatch(getMasSeries())
    } else if (
      portal.ex_agrupacion_perfiles === 'P' &&
      (!exPerfiles.perfiles?.perfiles || exPerfiles.perfiles.perfiles.length === 0)
    ) {
      dispatch(getMasPerfiles())
    }

    prevPerfiles.current = exPerfiles.perfiles.perfiles
  }, [])

  const onClick = e => {
    e.preventDefault()
    anadirFiltro(e)
  }

  const onClickRegresar = e => {
    e.preventDefault()
    eliminarFiltro(e)
  }

  const masGrupos = e => {
    e.preventDefault()

    let grupos_siguiente

    if (exGrupos.grupos.grupos_siguiente) {
      grupos_siguiente = exGrupos.grupos.grupos_siguiente
    }

    dispatch(getMasGrupos(grupos_siguiente))
  }

  const masSeries = e => {
    e.preventDefault()
    let series_siguiente

    if (exSeries.series.series_siguiente) {
      series_siguiente = exSeries.series.series_siguiente
    }

    dispatch(getMasSeries(series_siguiente, exGrupos.grupo_seleccionado))
  }

  const masSubSeries = e => {
    e.preventDefault()
    let subseries_siguiente

    if (exSubseries.subseries.subseries_siguiente) {
      subseries_siguiente = exSubseries.subseries.subseries_siguiente
    }

    dispatch(
      getMasSubSeries(
        subseries_siguiente,
        exGrupos.grupo_seleccionado,
        exSeries.serie_seleccionada,
      ),
    )
  }

  const masPerfiles = e => {
    e.preventDefault()
    let perfiles_siguiente

    if (exPerfiles.perfiles.perfiles_siguiente) {
      perfiles_siguiente = exPerfiles.perfiles.perfiles_siguiente
    }

    dispatch(
      getMasPerfiles(
        perfiles_siguiente,
        exGrupos.grupo_seleccionado,
        exSeries.serie_seleccionada,
        exSubseries.subserie_seleccionada,
      ),
    )
  }

  const eliminarFiltro = e => {
    if (exPerfiles?.perfil_seleccionado) {
      dispatch(unsetPerfilSeleccionado())

      if (portal.ex_agrupacion_perfiles === 'P') {
        dispatch(getMasPerfiles('', '', '', ''))
      } else {
        dispatch(
          getMasPerfiles(
            '',
            exGrupos.grupo_seleccionado,
            exSeries.serie_seleccionada,
            exSubseries.subserie_seleccionada,
          ),
        )
      }
    } else if (exSubseries?.subserie_seleccionada) {
      dispatch(unsetExSubSerieSeleccionada())
      dispatch(unsetPerfilSeleccionado())
      dispatch(getMasSubSeries('', exGrupos.grupo_seleccionado, exSeries.serie_seleccionada))
    } else if (exSeries?.serie_seleccionada) {
      dispatch(unsetExSerieSeleccionada())
      dispatch(unsetExSubSerieSeleccionada())
      dispatch(unsetPerfilSeleccionado())
      dispatch(getMasSeries('', exGrupos.grupo_seleccionado))
    } else if (exGrupos?.grupo_seleccionado) {
      dispatch(unsetExGrupoSeleccionado())
      dispatch(unsetExSerieSeleccionada())
      dispatch(unsetExSubSerieSeleccionada())
      dispatch(unsetPerfilSeleccionado())
      dispatch(getMasGrupos())
    }
  }

  const anadirFiltro = e => {
    if (e.currentTarget.dataset?.perfil) {
      let _codigo_grupo = e.currentTarget.dataset.grupo
      let _codigo_serie = e.currentTarget.dataset.serie
      let _codigo_subserie = e.currentTarget.dataset.subserie
      let _codigo_perfil = e.currentTarget.dataset.perfil
      let _nombre_perfil = e.currentTarget.dataset.nombre_perfil

      if (!exGrupos?.grupo_seleccionado || exGrupos.grupo_seleccionado !== _codigo_grupo) {
        dispatch(setExGrupoSeleccionado(_codigo_grupo))
        dispatch(getExGrupos())
      }

      if (!exSeries?.serie_seleccionada || exSeries.serie_seleccionada !== _codigo_serie) {
        dispatch(setExSerieSeleccionada(_codigo_serie))
        dispatch(getExSeries(_codigo_grupo))
      }

      if (
        !exSubseries?.subseries?.subseries ||
        exSubseries.subseries.subseries.length === 0 ||
        exSubseries.subserie_seleccionada !== _codigo_subserie
      ) {
        dispatch(setExSubSerieSeleccionada(_codigo_subserie))
        dispatch(getExSubSeries(_codigo_grupo, _codigo_serie))
      }

      dispatch(setPerfilSeleccionado(_codigo_perfil, _nombre_perfil))
    } else if (e.currentTarget.dataset?.subserie) {
      let _codigo_grupo = e.currentTarget.dataset.grupo
      let _codigo_serie = e.currentTarget.dataset.serie
      let _codigo_subserie = e.currentTarget.dataset.subserie

      // Por si se ten�a cubierto el estado anteriormente
      dispatch(unsetPerfilSeleccionado())

      if (!exGrupos?.grupo_seleccionado || exGrupos.grupo_seleccionado !== _codigo_grupo) {
        dispatch(setExGrupoSeleccionado(_codigo_grupo))
        dispatch(getExGrupos())
      }

      if (!exSeries?.serie_seleccionada || exSeries.serie_seleccionada !== _codigo_serie) {
        dispatch(setExSerieSeleccionada(_codigo_serie))
        dispatch(getExSeries(_codigo_grupo))
      }

      if (
        !exSubseries?.subseries?.subseries ||
        exSubseries.subseries.subseries.length === 0 ||
        exSubseries.subserie_seleccionada !== _codigo_subserie
      ) {
        dispatch(setExSubSerieSeleccionada(_codigo_subserie))
        dispatch(getExSubSeries(_codigo_grupo, _codigo_serie))
      }

      if (
        !exPerfiles.perfiles.perfiles ||
        exPerfiles.perfiles.perfiles.length === 0 ||
        exPerfiles.perfiles.subserie_perfil !== _codigo_subserie
      ) {
        dispatch(getMasPerfiles(null, _codigo_grupo, _codigo_serie, _codigo_subserie))
        // if (exPerfiles.perfiles.perfiles.length > 0 && !cargandoImagenes) {
        //   dispatch(getImagenesPerfiles())
        // }
      }
    } else if (e.currentTarget.dataset?.serie) {
      let _codigo_grupo = e.currentTarget.dataset.grupo
      let _codigo_serie = e.currentTarget.dataset.serie
      let _nombre_serie = e.currentTarget.dataset.nombre_serie

      if (portal.ex_agrupacion_perfiles === 'GSBP') {
        if (!exGrupos?.grupo_seleccionado) {
          dispatch(getExGrupos())
          dispatch(setExGrupoSeleccionado(_codigo_grupo))
        }
        if (!exSeries?.series?.series || exSeries.series.series.length === 0) {
          dispatch(getExSeries(_codigo_serie))
        }
        dispatch(setExSerieSeleccionada(_codigo_serie, _nombre_serie))

        if (
          !exSubseries?.subseries?.subseries ||
          exSubseries.subseries.subseries.length === 0 ||
          exSubseries.subseries.codigo_serie !== _codigo_serie
        ) {
          dispatch(getMasSubSeries(null, _codigo_grupo, _codigo_serie))
        }
        //Puede que un perfil no tenga subserie
        if (!exSubseries.isLoading && exSubseries.subseries.subseries.length === 0) {
          dispatch(getMasPerfiles(null, _codigo_grupo, _codigo_serie, null))
          // if (exPerfiles.perfiles.perfiles.length > 0 && !cargandoImagenes) {
          //   dispatch(getImagenesPerfiles())
          // }
        }
        //
      } else if (
        portal.ex_agrupacion_perfiles === 'GSP' ||
        portal.ex_agrupacion_perfiles === 'SP'
      ) {
        if (!exSeries?.series?.series || exSeries.series.series.length === 0) {
          dispatch(getExSeries(_codigo_serie))
        }
        dispatch(setExSerieSeleccionada(_codigo_serie, _nombre_serie))

        dispatch(getMasPerfiles(null, _codigo_grupo, _codigo_serie, null))
        // if (exPerfiles.perfiles.perfiles.length > 0 && !cargandoImagenes) {
        //   dispatch(getImagenesPerfiles())
        // }
      }
    } else if (e.currentTarget.dataset?.grupo) {
      let _codigo_grupo = e.currentTarget.dataset.grupo
      let _nombre_grupo = e.currentTarget.dataset.nombre
      dispatch(setExGrupoSeleccionado(_codigo_grupo, _nombre_grupo))

      if (
        !exSeries?.series?.series ||
        exSeries.series.series.length === 0 ||
        exSeries.series.grupo_perfil !== _codigo_grupo
      ) {
        dispatch(getMasSeries(null, _codigo_grupo))
      }
    }

    //this.props.history.push('/articulos_extrusion')
  }

  if (exGrupos.isLoading || exSeries.isLoading || exSubseries.isLoading || exPerfiles.isLoading) {
    return (
      <div className='tt-menu-extrusion container'>
        <div
          className='tt-menu-extrusion row'
          style={{ visibility: 'hidden' }}
          itemScope=''
          itemType='https://schema.org/ItemList'>
          {/* <Spinner showSpinner={true} /> */}
        </div>
      </div>
    )
  }

  if (
    exPerfiles.perfil_seleccionado &&
    (exSubseries.subserie_seleccionada || exSubseries.subseries.subseries.length === 0) &&
    (exSeries.serie_seleccionada || exSeries.series.series.length === 0) &&
    exGrupos.grupo_seleccionado
  ) {
    return (
      <div className='container-indent grupos-menu-extrusion'>
        <h1 className='tt-title'>{i18n.t('articulos_extrusion.titped')}</h1>
        <div className='col-12 mt-2 mb-2 boton_regresar'>
          <button
            type='button'
            className='btn btn-warning'
            onClick={onClickRegresar}>
            <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvperf')}
          </button>
        </div>
        <div className='tt-menu-extrusion container'>
          <FormularioExtrusion />
        </div>
      </div>
    )
  } else if (
    exSubseries.subserie_seleccionada &&
    exSeries.serie_seleccionada &&
    exGrupos.grupo_seleccionado
  ) {
    if (exPerfiles.isLoading) {
      return (
        <div className='tt-menu-extrusion container'>
          <div
            className='tt-menu-extrusion row'
            style={{ visibility: 'hidden' }}
            itemScope=''
            itemType='https://schema.org/ItemList'>
            {/* <Spinner showSpinner={true} /> */}
          </div>
        </div>
      )
    } else {
      if (exPerfiles?.perfiles && exPerfiles.perfiles.perfiles.length > 0) {
        return (
          <Fragment>
            <div className='container-indent grupos-menu-extrusion'>
              <div className='container-fluid'>
                <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
                <div className='col-12 mt-2 mb-2 boton_regresar'>
                  <button
                    type='button'
                    className='btn btn-warning'
                    onClick={onClickRegresar}>
                    <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvsubs')}
                  </button>
                </div>
                <div className='tt-menu-extrusion container'>
                  <div
                    className={
                      modo_listado !== null && modo_listado === 'L'
                        ? 'tt-menu-extrusion listado'
                        : 'tt-menu-extrusion row'
                    }
                    itemScope
                    itemType='https://schema.org/ItemList'>
                    {exPerfiles?.perfiles?.perfiles?.length > 0 &&
                      exPerfiles.perfiles.perfiles.map(perfil => {
                        return (
                          <ElementoGridExtrusion
                            key={perfil.id}
                            id={perfil.id}
                            className={
                              modo_listado && modo_listado === 'L'
                                ? 'col-12 tt-col-item row-listado'
                                : 'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'
                            }
                            codigoGrupo={perfil.grupo_serie}
                            codigoSerie={perfil.serie}
                            codigoSubserie={perfil.subserie_perfil}
                            codigoPerfil={perfil.codigo_perfil}
                            nombrePerfil={perfil.desc_perfil}
                            codigoOriginal={perfil.codigo_original}
                            codigoReferencia={perfil.codigo_referencia}
                            onClick={onClick}
                            nombreDisplayed={perfil.desc_perfil}
                            esBusqueda={false}
                            esPerfil={true}
                            modoListado={modo_listado}
                          />
                        )
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className='text-center mt-5'>
              {exPerfiles.perfiles?.perfiles.length > 0 &&
              exPerfiles?.perfiles?.perfiles_siguiente ? (
                <button
                  onClick={masPerfiles}
                  className='btn btn-border'>
                  {i18n.t('articulos_extrusion.masperf')}
                </button>
              ) : (
                ''
              )}
            </div>
          </Fragment>
        )
      } else {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
            <div className='col-12 mt-2 mb-2 volver_subseries'>
              <button
                type='button'
                className='btn btn-warning'
                onClick={onClickRegresar}>
                <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvsubs')}
              </button>
            </div>
          </div>
        )
      }
    }
  } else if (portal.ex_agrupacion_perfiles === 'P' && !exPerfiles?.perfil_seleccionado) {
    if (exPerfiles.isLoading) {
      return (
        <div className='tt-menu-extrusion container'>
          <div
            className='tt-menu-extrusion row'
            style={{ visibility: 'hidden' }}
            itemScope=''
            itemType='https://schema.org/ItemList'>
            {/* <Spinner showSpinner={true} /> */}
          </div>
        </div>
      )
    } else {
      if (exPerfiles?.perfiles && exPerfiles.perfiles.perfiles.length > 0) {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <div className='container-fluid'>
              <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
              {portal.ex_agrupacion_perfiles !== 'P' ? (
                <div className='col-12 mt-2 mb-2 boton_regresar'>
                  <button
                    type='button'
                    className='btn btn-warning'
                    onClick={onClickRegresar}>
                    <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvser')}
                  </button>
                </div>
              ) : (
                ''
              )}
              <div className='tt-menu-extrusion container'>
                <div
                  className={
                    modo_listado && modo_listado === 'L'
                      ? 'tt-menu-extrusion listado'
                      : 'tt-menu-extrusion row'
                  }
                  itemScope
                  itemType='https://schema.org/ItemList'>
                  {exPerfiles?.perfiles?.perfiles?.length > 0 &&
                    exPerfiles.perfiles.perfiles.map(perfil => {
                      return (
                        <ElementoGridExtrusion
                          key={perfil.id}
                          id={perfil.id}
                          className={
                            modo_listado && modo_listado === 'L'
                              ? 'col-12 tt-col-item row-listado'
                              : 'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'
                          }
                          codigoGrupo={perfil.grupo_serie}
                          codigoSerie={perfil.serie}
                          codigoSubserie={perfil.subserie_perfil}
                          codigoPerfil={perfil.codigo_perfil}
                          nombrePerfil={perfil.desc_perfil}
                          onClick={onClick}
                          nombreDisplayed={perfil.desc_perfil}
                          codigoOriginal={perfil.codigoOriginal}
                          codigoReferencia={perfil.codigo_referencia}
                          esBusqueda={false}
                          esPerfil={true}
                          modoListado={modo_listado}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
            <div className='text-center mt-5'>
              {exSubseries.subseries.subseries.length > 0 &&
              exSubseries?.subseries.subseries_siguiente &&
              !exPerfiles.perfiles.perfil_seleccionado ? (
                <button
                  onClick={masSubSeries}
                  className='btn btn-border'>
                  {i18n.t('articulos_extrusion.massubs')}
                </button>
              ) : (
                <>
                  {exSubseries.subseries.subseries.length === 0 &&
                  exPerfiles?.perfiles?.perfiles_siguiente ? (
                    <button
                      onClick={masPerfiles}
                      className='btn btn-border'>
                      {i18n.t('articulos_extrusion.masperf')}
                    </button>
                  ) : (
                    <>
                      {exSubseries.subseries.subseries.length > 0 &&
                      !exSubseries?.subseries.subseries_siguiente &&
                      !exPerfiles.perfiles.perfil_seleccionado ? (
                        <button className='btn btn-border01'>
                          {i18n.t('articulos_extrusion.nohaysubs').toUpperCase()}
                        </button>
                      ) : (
                        <>
                          {exSubseries.subseries.subseries.length === 0 &&
                          !exPerfiles?.perfiles?.perfiles_siguiente &&
                          exPerfiles.perfiles.perfiles.length > 0 ? (
                            <button className='btn btn-border01'>
                              {i18n.t('articulos_extrusion.nohayperf').toUpperCase()}
                            </button>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        )
      } else {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
            <div className='col-12 mt-2 mb-2 volver_subseries'>
              <button
                type='button'
                className='btn btn-warning'
                onClick={onClickRegresar}>
                <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvsubs')}
              </button>
            </div>
          </div>
        )
      }
    }
  } else if (portal.ex_agrupacion_perfiles === 'SP' && exSeries?.serie_seleccionada) {
    if (exPerfiles.isLoading) {
      return (
        <div className='tt-menu-extrusion container'>
          <div
            className='tt-menu-extrusion row'
            style={{ visibility: 'hidden' }}
            itemScope=''
            itemType='https://schema.org/ItemList'>
            {/* <Spinner showSpinner={true} /> */}
          </div>
        </div>
      )
    } else {
      if (exPerfiles?.perfiles && exPerfiles.perfiles.perfiles.length > 0) {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <div className='container-fluid'>
              <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
              <div className='col-12 mt-2 mb-2 boton_regresar'>
                <button
                  type='button'
                  className='btn btn-warning'
                  onClick={onClickRegresar}>
                  <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvser')}
                </button>
              </div>
              <div className='tt-menu-extrusion container'>
                <div
                  className={
                    modo_listado && modo_listado === 'L'
                      ? 'tt-menu-extrusion listado'
                      : 'tt-menu-extrusion row'
                  }
                  itemScope
                  itemType='https://schema.org/ItemList'>
                  {exPerfiles?.perfiles?.perfiles?.length > 0 &&
                    exPerfiles.perfiles.perfiles.map(perfil => {
                      return (
                        <ElementoGridExtrusion
                          key={perfil.id}
                          id={perfil.id}
                          codigoOriginal={perfil.codigo_original}
                          codigoReferencia={perfil.codigo_referencia}
                          className={
                            modo_listado && modo_listado === 'L'
                              ? 'col-12 tt-col-item row-listado'
                              : 'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'
                          }
                          codigoGrupo={perfil.grupo_serie}
                          codigoSerie={perfil.serie}
                          codigoSubserie={perfil.subserie_perfil}
                          codigoPerfil={perfil.codigo_perfil}
                          nombrePerfil={perfil.desc_perfil}
                          onClick={onClick}
                          nombreDisplayed={perfil.desc_perfil}
                          esBusqueda={false}
                          esPerfil={true}
                          modoListado={modo_listado}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
            <div className='text-center mt-5'>
              {exSubseries.subseries.subseries.length > 0 &&
              exSubseries?.subseries.subseries_siguiente &&
              !exPerfiles.perfiles.perfil_seleccionado ? (
                <button
                  onClick={masSubSeries}
                  className='btn btn-border'>
                  {i18n.t('articulos_extrusion.massubs').toUpperCase()}
                </button>
              ) : (
                <>
                  {exSubseries.subseries.subseries.length === 0 &&
                  exPerfiles?.perfiles?.perfiles_siguiente ? (
                    <button
                      onClick={masPerfiles}
                      className='btn btn-border'>
                      {i18n.t('articulos_extrusion.masperf').toUpperCase()}
                    </button>
                  ) : (
                    <>
                      {exSubseries.subseries.subseries.length > 0 &&
                      !exSubseries?.subseries.subseries_siguiente &&
                      !exPerfiles.perfiles.perfil_seleccionado ? (
                        <button className='btn btn-border01'>
                          {i18n.t('articulos_extrusion.nohaysubs').toUpperCase()}
                        </button>
                      ) : (
                        <>
                          {exSubseries.subseries.subseries.length === 0 &&
                          !exPerfiles?.perfiles?.perfiles_siguiente &&
                          exPerfiles.perfiles.perfiles.length > 0 ? (
                            <button className='btn btn-border01'>
                              {i18n.t('articulos_extrusion.nohayperf').toUpperCase()}
                            </button>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        )
      } else {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
            <div className='col-12 mt-2 mb-2 volver_subseries'>
              <button
                type='button'
                className='btn btn-warning'
                onClick={onClickRegresar}>
                <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvsubs')}
              </button>
            </div>
          </div>
        )
      }
    }
  } else if (
    (portal.ex_agrupacion_perfiles === 'GSBP' || portal.ex_agrupacion_perfiles === 'GSP') &&
    exSeries.serie_seleccionada &&
    exGrupos.grupo_seleccionado
  ) {
    if (exSubseries.isLoading) {
      return (
        <div className='tt-menu-extrusion container'>
          <div
            className='tt-menu-extrusion row'
            style={{ visibility: 'hidden' }}
            itemScope=''
            itemType='https://schema.org/ItemList'>
            {/* <Spinner showSpinner={true} /> */}
          </div>
        </div>
      )
    } else {
      if (exSubseries.subseries.subseries && exSubseries.subseries.subseries.length > 0) {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <div className='container-fluid'>
              <h1 className='tt-title'>{i18n.t('articulos_extrusion.titsubs')}</h1>
              <div className='col-12 mt-2 mb-2 boton_regresar'>
                <button
                  type='button'
                  className='btn btn-warning'
                  onClick={onClickRegresar}>
                  <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvser')}
                </button>
              </div>
              <div className='tt-menu-extrusion container'>
                <div
                  className='tt-menu-extrusion row'
                  itemScope
                  itemType='https://schema.org/ItemList'>
                  {exSubseries?.subseries?.subseries?.length > 0 &&
                    exSubseries.subseries.subseries.map(subserie => {
                      return (
                        <ElementoGridExtrusion
                          key={subserie.id}
                          id={subserie.id}
                          className={'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'}
                          codigoGrupo={subserie.grupo_perfil}
                          codigoSerie={subserie.codigo_serie}
                          codigoSubserie={subserie.codigo}
                          nombreSubserie={subserie.nombre}
                          onClick={onClick}
                          imagen={subserie.imagen}
                          nombreDisplayed={subserie.nombre}
                          esBusqueda={false}
                          modoListado={modo_listado}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
            <div className='text-center mt-5'>
              {exSubseries.subseries.subseries.length > 0 &&
              exSubseries?.subseries.subseries_siguiente &&
              !exPerfiles.perfiles.perfil_seleccionado ? (
                <button
                  onClick={masSubSeries}
                  className='btn btn-border'>
                  {i18n.t('articulos_extrusion.massubs')}
                </button>
              ) : (
                <>
                  {exSubseries.subseries.subseries.length === 0 &&
                  exPerfiles?.perfiles?.perfiles_siguiente ? (
                    <button
                      onClick={masPerfiles}
                      className='btn btn-border'>
                      {i18n.t('articulos_extrusion.masperf')}
                    </button>
                  ) : (
                    <>
                      {exSubseries.subseries.subseries.length > 0 &&
                      !exSubseries?.subseries.subseries_siguiente &&
                      !exPerfiles.perfiles.perfil_seleccionado ? (
                        <button className='btn btn-border01'>
                          {i18n.t('articulos_extrusion.nohaysubs')}
                        </button>
                      ) : (
                        <>
                          {exSubseries.subseries.subseries.length === 0 &&
                          !exPerfiles?.perfiles?.perfiles_siguiente &&
                          exPerfiles.perfiles.perfiles.length > 0 ? (
                            <button className='btn btn-border01'>
                              {i18n.t('articulos_extrusion.nohayperf')}
                            </button>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        )
      } else {
        if (exPerfiles?.perfiles && exPerfiles.perfiles.perfiles.length > 0) {
          return (
            <div className='container-indent grupos-menu-extrusion'>
              <div className='container-fluid'>
                <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
                <div className='col-12 mt-2 mb-2 boton_regresar'>
                  <button
                    type='button'
                    className='btn btn-warning'
                    onClick={onClickRegresar}>
                    <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvser')}
                  </button>
                </div>
                <div className='tt-menu-extrusion container'>
                  <div
                    className={
                      modo_listado && modo_listado === 'L'
                        ? 'tt-menu-extrusion listado'
                        : 'tt-menu-extrusion row'
                    }
                    itemScope
                    itemType='https://schema.org/ItemList'>
                    {exPerfiles?.perfiles?.perfiles?.length > 0 &&
                      exPerfiles.perfiles.perfiles.map(perfil => {
                        return (
                          <ElementoGridExtrusion
                            key={perfil.id}
                            id={perfil.id}
                            className={
                              modo_listado && modo_listado === 'L'
                                ? 'col-12 tt-col-item row-listado'
                                : 'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'
                            }
                            codigoOriginal={perfil.codigo_original}
                            codigoReferencia={perfil.codigo_referencia}
                            codigoGrupo={perfil.grupo_serie}
                            codigoSerie={perfil.serie}
                            codigoSubserie={perfil.subserie_perfil}
                            codigoPerfil={perfil.codigo_perfil}
                            nombrePerfil={perfil.desc_perfil}
                            onClick={onClick}
                            nombreDisplayed={perfil.desc_perfil}
                            esBusqueda={false}
                            esPerfil={true}
                            modoListado={modo_listado}
                          />
                        )
                      })}
                  </div>
                </div>
              </div>
              <div className='text-center mt-5'>
                {exSubseries.subseries.subseries.length > 0 &&
                exSubseries?.subseries.subseries_siguiente &&
                !exPerfiles.perfiles.perfil_seleccionado ? (
                  <button
                    onClick={masSubSeries}
                    className='btn btn-border'>
                    {i18n.t('articulos_extrusion.massubs')}
                  </button>
                ) : (
                  <>
                    {exSubseries.subseries.subseries.length === 0 &&
                    exPerfiles?.perfiles?.perfiles_siguiente ? (
                      <button
                        onClick={masPerfiles}
                        className='btn btn-border'>
                        {i18n.t('articulos_extrusion.masperf')}
                      </button>
                    ) : (
                      <>
                        {exSubseries.subseries.subseries.length > 0 &&
                        !exSubseries?.subseries.subseries_siguiente &&
                        !exPerfiles.perfiles.perfil_seleccionado ? (
                          <button className='btn btn-border01'>
                            {i18n.t('articulos_extrusion.nohaysubs')}
                          </button>
                        ) : (
                          <>
                            {exSubseries.subseries.subseries.length === 0 &&
                            !exPerfiles?.perfiles?.perfiles_siguiente &&
                            exPerfiles.perfiles.perfiles.length > 0 ? (
                              <button className='btn btn-border01'>
                                {i18n.t('articulos_extrusion.nohayperf')}
                              </button>
                            ) : (
                              ''
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          )
        } else {
          return (
            <div className='container-indent grupos-menu-extrusion'>
              <h1 className='tt-title'>{i18n.t('articulos_extrusion.titperf')}</h1>
              <div className='col-12 mt-2 mb-2 volver_subseries'>
                <button
                  type='button'
                  className='btn btn-warning'
                  onClick={onClickRegresar}>
                  <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvsubs')}
                </button>
              </div>
            </div>
          )
        }
      }
    }
  } else if (exGrupos?.grupo_seleccionado) {
    if (exSeries.isLoading) {
      return (
        <div className='tt-menu-extrusion container'>
          <div
            className='tt-menu-extrusion row'
            style={{ visibility: 'hidden' }}
            itemScope=''
            itemType='https://schema.org/ItemList'>
            {/* <Spinner showSpinner={true} /> */}
          </div>
        </div>
      )
    } else if (exSeries?.series?.series && exSeries.series.series.length > 0) {
      return (
        <div className='container-indent grupos-menu-extrusion'>
          <div className='container-fluid'>
            <h1 className='tt-title'>{i18n.t('articulos_extrusion.titser')}</h1>
            <div className='col-12 mt-2 mb-2 boton_regresar'>
              <button
                type='button'
                className='btn btn-warning'
                onClick={onClickRegresar}>
                <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvgru')}
              </button>
            </div>
            <div className='tt-menu-extrusion container'>
              <div
                className='tt-menu-extrusion row'
                itemScope
                itemType='https://schema.org/ItemList'>
                {exSeries?.series?.series?.length > 0 &&
                  exSeries.series.series.map(serie => {
                    return (
                      <ElementoGridExtrusion
                        key={serie.id}
                        id={serie.id}
                        className={'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'}
                        codigoGrupo={serie.grupo_perfil}
                        codigoSerie={serie.codigo}
                        nombreSerie={serie.nombre}
                        onClick={onClick}
                        imagen={serie.imagen}
                        nombreDisplayed={serie.nombre}
                        esBusqueda={false}
                        modoListado={modo_listado}
                      />
                    )
                  })}
              </div>
            </div>
          </div>
          <div className='text-center mt-5'>
            {exSeries.series.series_siguiente !== null &&
            exSeries.series.series_siguiente !== '' ? (
              <button
                onClick={masSeries}
                className='btn btn-border'>
                {i18n.t('articulos_extrusion.masseri')}
              </button>
            ) : (
              <button className='btn btn-border01'>{i18n.t('articulos_extrusion.nohayser')}</button>
            )}
          </div>
        </div>
      )
    } else {
      return (
        <div className='container-indent grupos-menu-extrusion'>
          <h1 className='tt-title'>{i18n.t('articulos_extrusion.titser')}</h1>
          <h2>
            <button
              type='button'
              className='btn btn-warning'
              onClick={onClickRegresar}>
              <i className='lni lni-backward'></i> {i18n.t('articulos_extrusion.volvgru')}
            </button>
          </h2>
          <h3>
            <button className='btn btn-border01'>{i18n.t('articulos_extrusion.nosergru')}</button>
          </h3>
        </div>
      )
    }
  } else {
    if (exGrupos.isLoading || exSeries.isLoading) {
      return (
        <div className='tt-menu-extrusion container'>
          <div
            className='tt-menu-extrusion row'
            style={{ visibility: 'hidden' }}
            itemScope=''
            itemType='https://schema.org/ItemList'>
            {/* <Spinner showSpinner={true} /> */}
          </div>
        </div>
      )
    } else if (
      (portal.ex_agrupacion_perfiles === 'GSBP' || portal.ex_agrupacion_perfiles === 'GSP') &&
      exGrupos?.grupos?.grupos &&
      exGrupos.grupos.grupos.length > 0 &&
      exSeries.series.series.length === 0 &&
      exSubseries.subseries.subseries.length === 0 &&
      exPerfiles.perfiles.perfiles.length === 0
    ) {
      return (
        <div className='container-indent grupos-menu-extrusion'>
          <div className='container-fluid'>
            <h1 className='tt-title'>{i18n.t('articulos_extrusion.titgrup')}</h1>
            <div className='tt-menu-extrusion container'>
              <div
                className='tt-menu-extrusion row'
                itemScope
                itemType='https://schema.org/ItemList'>
                {exGrupos?.grupos?.grupos?.length > 0 &&
                  exGrupos?.grupos?.grupos?.map(grupo => {
                    return (
                      <ElementoGridExtrusion
                        key={grupo.id}
                        id={grupo.id}
                        className={'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'}
                        codigoGrupo={grupo.codigo}
                        nombreGrupo={grupo.nombre}
                        onClick={onClick}
                        imagen={grupo.imagen}
                        nombreDisplayed={grupo.nombre}
                        esBusqueda={false}
                        modoListado={modo_listado}
                      />
                    )
                  })}
              </div>
            </div>
          </div>
          <div className='text-center mt-5'>
            {exGrupos?.grupos?.grupos_siguiente ? (
              <button
                onClick={masGrupos}
                className='btn btn-border'>
                {i18n.t('articulos_extrusion.masgrup')}
              </button>
            ) : (
              <button className='btn btn-border01'>
                {i18n.t('articulos_extrusion.nohaygru').toUpperCase()}
              </button>
            )}
          </div>
        </div>
      )
    } else if (
      portal.ex_agrupacion_perfiles === 'SP' &&
      exSeries?.series?.series &&
      exSeries.series.series.length > 0 &&
      exPerfiles.perfiles.perfiles.length === 0
    ) {
      if (exSeries.isLoading) {
        return (
          <div className='tt-menu-extrusion container'>
            <div
              className='tt-menu-extrusion row'
              style={{ visibility: 'hidden' }}
              itemScope=''
              itemType='https://schema.org/ItemList'>
              {/* <Spinner showSpinner={true} /> */}
            </div>
          </div>
        )
      } else {
        return (
          <div className='container-indent grupos-menu-extrusion'>
            <div className='container-fluid'>
              <h1 className='tt-title'>{i18n.t('articulos_extrusion.titser')}</h1>
              <div className='tt-menu-extrusion container'>
                <div
                  className='tt-menu-extrusion row'
                  itemScope
                  itemType='https://schema.org/ItemList'>
                  {exSeries?.series?.series?.length > 0 &&
                    exSeries.series.series.map(serie => {
                      return (
                        <ElementoGridExtrusion
                          key={serie.id}
                          id={serie.id}
                          className={'col-6 col-sm-4 col-md-4 col-lg-3 tt-col-item'}
                          codigoGrupo={serie.grupo_perfil}
                          codigoSerie={serie.codigo}
                          nombreSerie={serie.nombre}
                          onClick={onClick}
                          imagen={serie.imagen}
                          nombreDisplayed={serie.nombre}
                          esBusqueda={false}
                          modoListado={modo_listado}
                        />
                      )
                    })}
                </div>
              </div>
            </div>
            <div className='text-center mt-5'>
              {exSeries.series_siguiente ? (
                <button
                  onClick={masSeries}
                  className='btn btn-border'>
                  {i18n.t('articulos_extrusion.masseri')}
                </button>
              ) : (
                <button className='btn btn-border01'>
                  {i18n.t('articulos_extrusion.nohayser')}
                </button>
              )}
            </div>
          </div>
        )
      }
    } else {
      // Se muestran los resultados de la b�squeda, separados en listas de grupos / series / subseries / perfiles
      const grupos_obtenidos = obtenerGruposBusqueda(exGrupos, onClick)
      const series_obtenidas = obtenerSeriesBusqueda(exSeries, onClick)
      const subseries_obtenidas = obtenerSubseriesBusqueda(exSubseries, onClick)
      const perfiles_obtenidos = obtenerPerfilesBusqueda(exPerfiles, onClick, modo_listado)

      return (
        <div className='container-indent grupos-menu-extrusion'>
          <div className='container-fluid'>
            <h1 className='tt-title'>{i18n.t('articulos_extrusion.resulbus')}</h1>
            <div className='tt-menu-extrusion container'></div>
            {grupos_obtenidos}
            {series_obtenidas}
            {subseries_obtenidas}
            {exPerfiles.isLoading ? (
              <div className='tt-menu-extrusion container'>
                <div
                  className='tt-menu-extrusion row'
                  style={{ visibility: 'hidden' }}
                  itemScope=''
                  itemType='https://schema.org/ItemList'>
                  {/* <Spinner showSpinner={true} /> */}
                </div>
              </div>
            ) : (
              perfiles_obtenidos
            )}
          </div>
        </div>
      )
    }
  }
}

export default MenuExtrusion
